
<!-- //<div class="padding-alert" *ngIf="alertSuccess || alertFailure || deleteSuccess || noUser || alertError || userFound"> -->
    <div class="alert alert-success" *ngIf="alertSuccess">
        NAAC Admin added successfully!
      </div>
      <div class="alert alert-danger" *ngIf="alertFailure">
         {{errorMsg}} !
      </div>
      <div class="alert alert-success" *ngIf="deleteSuccess">
        NAAC Admin deleted successfully!
      </div>
      <div class="alert alert-danger" *ngIf="noUser">
        No user found !
      </div>
      <div class="alert alert-success" *ngIf="userFound">
        Please select from user dropdown
        </div>
      <div class="alert alert-danger" *ngIf="alertError">
       Something went wrong !!!
      </div>
      <div class="alert alert-danger" *ngIf="timeOutError">
        {{timeoutErrorMessage}}
      </div>	
    <!-- </div>   -->
  
  <div class="col-sm-12 col-md-12 col-xl-12">
    <div class="adminTitle">NAAC Admin Management</div>
  
    <br><br>
    <div class="mainSection searchBy"> 
      <div class="search-tag"><input type="text" class="form-control width-class" maxlength="50" placeholder="Search by first name, last name, email id or workday id"
        [(ngModel)]="searchTerm">
   <!-- <a (click)="searchBy()" class="image-search">
              <img src="assets/images/search.png" (click)="searchBy()"/></a> -->
              <button type="button" class="btn btn-danger image-search" (click)="searchBy()">SEARCH</button>
  
      </div>
        </div>
    <form (ngSubmit)="onSubmit()" name="form" #myForm="ngForm">
      <div class="mainSection">     
          <label class="searchlabel">Select Users <span class="star"> *</span></label><span  class="colon">:</span>
          <div class = "selectDropSet">
          <ng-select placeholder ="Select User" name = "userName"  class="custom" [items] = "userList" bindLabel ="userFirstName" bindValue="userId" [(ngModel)]="userFirstName" (blur)="duplicateHandler()" (change)="userSelection($event)" required >
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div>{{item.userFirstName}}</div>
                <div *ngIf="item.division" style="font-size: 11px">{{item.division}}</div>
                <div *ngIf="item.classification" style="font-size: 11px">{{item.classification}}</div>
              </ng-template>
          </ng-select> 
        </div>
       
        <label class="searchlabel">Name</label><span class="colon">:</span><span class="datas">{{name}}</span>
  
        <div>
          <label class="searchlabel">Email Id</label><span class="colon">:</span><span class="datas">{{email}}</span>
        </div>
        <div>
          <label class="searchlabel">Workday Id</label><span  class="colon">:</span><span class="datas">{{workId}}</span>
        </div>
        <div>
            <label class="searchlabel">User Role</label><span class="colon">:</span><span class="datas">{{roleName}}</span>
          </div>
          <div>
            <label class="searchlabel">Select NAAC <span class="star"> *</span></label><span  class="colon">:</span>
            <div class = "selectDropSet">
           <ng-select placeholder ="Select NAAC" [(ngModel)] ="selectedNaac"  name = "bpgName" class="custom" [items] = "affinityList" bindLabel ="bpgName" bindValue="bpgId"  (change)="naacSelection()" required></ng-select> 
          </div>
          </div>
      </div>
      <div class="btn-div">
        <button type="submit" class="btn btn-danger"  [disabled]="!myForm.valid" data-toggle="modal" data-target="#myModal">ADD</button>
        <button type="button" class="btn btn-danger" (click)="resetClick()" data-toggle="modal" data-target="#myModal">RESET</button>
      </div>
  
    </form>
  <br>
  <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>
  
  
    <div class="outer-div">
      <div class="searchBox">
        <label for="search">Search</label>
        <input type="text" class="form-control" id="search" maxlength="50" placeholder="Search by name"
          [(ngModel)]="searchKey" (keyup.enter)="searchMe()">
      </div>
  </div>
  
  <p class="text-center" *ngIf="noDataFound"> No data found </p>
  <div id="tabledemo1"  *ngIf="tableShow">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col" (click)="sortMe('user_first_name')" class = "name">Name <span class="sortupdown"><i id="user_first_name1"
            class="fa fa-sort-up"></i><i id="user_first_name2" class="fa fa-sort-down"></i></span></th>
          <th scope="col">User Role</th>
          <th scope="col">NAAC Affinity</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of naacAdminData  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
          <td>{{data.userFirstName}}&nbsp;{{data.userLastName}}</td>
          <td>{{data.adminName}}</td>
          <td>{{data.naacAffinityName}}</td>
          <td>
            <a (click)="delete(data)" class="edit-delete" data-toggle="modal" data-target="#myModal"><img src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
          </td>
        </tr>
  
      </tbody>
    </table>
  </div>
  
  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
  </div>
  </div>
  
